<template>
  <v-container id="selectormatriculado-caplp">
    <v-row>
      <v-col cols="1" md="1" lg="1">
        <v-text-field
          v-model="nromatriculado"
          label="N°"
          v-on:keyup.enter="BuscarMatriculado"
          height="20px"
        />
      </v-col>
      <v-col cols="2" md="2" lg="2">
        <v-text-field
          v-model="dni"
          label="DNI"
          v-on:keyup.enter="BuscarMatriculado"
          height="20px"
        />
      </v-col>
      <v-col cols="5" md="7" lg="7">
        <v-text-field
          v-model="matriculado"
          label="Matriculado"
          v-on:keyup.enter="BuscarMatriculado"
          height="20px"
        />
      </v-col>
      <v-col cols="4" md="2" lg="2">
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Buscar"
          @click="BuscarMatriculado"
        >
          <v-icon
            dark
          >
            mdi-magnify
          </v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Quitar Filtro Matriculado"
          @click="QuitarMatriculado"
        >
          <v-icon
            dark
          >
            mdi-cancel
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogmensaje = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogselmatriculado" persistent max-width="1024">
      <v-card>
        <v-card-title class="headline">
          Seleccione Matriculado
        </v-card-title>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogselmatriculado = false">
            Cerrar
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="columnasmatriculados"
            :items="listamatriculados"
            :items-per-page="10"
            :footer-props="{'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text' : 'Todos'}"
            class="elevation-1"
            dense
            no-data-text="Sin Registros"
            multi-sort
            >
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="seleccionarMatriculado(item)"
              >
                mdi-arrow-right
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import axios from '@/axios'
  export default {
    props: ['idseleccionado'],
    data() {
      return {
        loading: false,
        dialogmensaje: false,
        mensajetitulo: '',
        mensajecuerpo: '',
        nromatriculado: '',
        dni: '',
        matriculado: '',
        listamatriculados: [],
        dialogselmatriculado: false,
        columnasmatriculados: [
          {
            text: 'Op.',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: 100
          },
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'idpersona',
            width: 15
          },
          {
            text: 'Apellido',
            align: 'center',
            sortable: true,
            value: 'apellido',
            width: 220
          },
          {
            text: 'Nombre',
            align: 'center',
            sortable: true,
            value: 'nombre',
            width: 220
          },
          {
            text: 'N° Matriculado',
            align: 'center',
            sortable: true,
            value: 'nromatriculadosisant',
            width: 150
          },
          {
            text: 'Documento',
            align: 'center',
            sortable: true,
            value: 'nrodoc',
            width: 150
          },
          {
            text: 'Fecha Nacim',
            align: 'left',
            sortable: true,
            value: 'fecnac',
            width: 150
          }
        ],
        //idsel: 0
      }
    },
    mounted() {
      this.nromatriculado='';
      this.dni='';
      this.matriculado='';
      //this.idsel=0;
      if(this.idseleccionado!=null && this.idseleccionado!=0){
        this.BuscarMatriculado();
      }
    },
    methods: {
      MostrarMensaje(titulo, cuerpo) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.dialogmensaje = true;
      },
      BuscarMatriculado (){
        this.loading = true
        var nromat= this.nromatriculado!='' ? this.nromatriculado : '0'
        var mat= this.matriculado!='' ? this.matriculado : ' '
        var dni= this.dni!='' ? + this.dni : '0'
        //var idper= this.idsel!=null && this.idsel!=0 ? this.idsel : '0';
        var idper= this.idseleccionado!=null && this.idseleccionado!=0 ? this.idseleccionado : '0';
        axios
          .get('matriculado/SelectorMatriculado/' + mat + '/0/' + nromat + '/' + idper + '/' + dni)
          .then((result) => {
            this.listamatriculados = result.data
            if(this.listamatriculados.length===0)
            {
              this.QuitarMatriculado();
              this.MostrarMensaje('Atención','No existen matriculados con los criterios seleccionados!!!')
            }
            else if(this.listamatriculados.length===1)
            {
              /*trae matriculado*/
              this.nromatriculado= this.listamatriculados[0].nromatriculadosisant
              this.dni= this.listamatriculados[0].nrodoc
              this.matriculado= this.listamatriculados[0].apenom
              this.$emit('selMatriculado', this.listamatriculados[0])
            }else{
              /*abre cuadro con lista para seleccionar*/
              this.dialogselmatriculado=true
            }
            this.loading = false
          })
          .catch((error) => {
            this.QuitarMatriculado();
            this.loading = false
            this.MostrarMensaje('Error', error)
          })
      },
      QuitarMatriculado () {
        this.nromatriculado=''
        this.dni=''
        this.matriculado=''
        this.listamatriculados=[]
        this.idseleccionado=0;
        this.$emit('selMatriculado', null)
      },
      seleccionarMatriculado (item) {
        this.loading=true
        this.nromatriculado= item.nromatriculadosisant
        this.dni= item.nrodoc
        this.matriculado= item.apenom
        this.$emit('selMatriculado', item)
        this.dialogselmatriculado=false
        this.loading=false
      }
    }
  };
</script>
<style>
  .textocentrado {
    text-align: center;
  }
  .elementocentrado {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .col-xl,
  .col-xl-auto,
  .col-xl-12,
  .col-xl-11,
  .col-xl-10,
  .col-xl-9,
  .col-xl-8,
  .col-xl-7,
  .col-xl-6,
  .col-xl-5,
  .col-xl-4,
  .col-xl-3,
  .col-xl-2,
  .col-xl-1,
  .col-lg,
  .col-lg-auto,
  .col-lg-12,
  .col-lg-11,
  .col-lg-10,
  .col-lg-9,
  .col-lg-8,
  .col-lg-7,
  .col-lg-6,
  .col-lg-5,
  .col-lg-4,
  .col-lg-3,
  .col-lg-2,
  .col-lg-1,
  .col-md,
  .col-md-auto,
  .col-md-12,
  .col-md-11,
  .col-md-10,
  .col-md-9,
  .col-md-8,
  .col-md-7,
  .col-md-6,
  .col-md-5,
  .col-md-4,
  .col-md-3,
  .col-md-2,
  .col-md-1,
  .col-sm,
  .col-sm-auto,
  .col-sm-12,
  .col-sm-11,
  .col-sm-10,
  .col-sm-9,
  .col-sm-8,
  .col-sm-7,
  .col-sm-6,
  .col-sm-5,
  .col-sm-4,
  .col-sm-3,
  .col-sm-2,
  .col-sm-1,
  .col,
  .col-auto,
  .col-12,
  .col-11,
  .col-10,
  .col-9,
  .col-8,
  .col-7,
  .col-6,
  .col-5,
  .col-4,
  .col-3,
  .col-2,
  .col-1 {
    padding: 2px !important;
  }
  @media only screen and (min-width: 960px) {
    .altojusto {
      height: 45px !important;
    }
  }
  .alineaizquierda {
    text-align: left !important;
  }
  .alineacentro {
    text-align: center;
  }
  .alineaderecha {
    text-align: right;
  }
  .ocupa10 {
    width: 10%;
  }
  .ocupa20 {
    width: 20%;
  }
  .ocupa30 {
    width: 30%;
  }
  .ocupa50 {
    width: 50%;
  }
  .ocupa75 {
    width: 75%;
  }
  .ocupa95 {
    width: 95%;
  }
  .centradovertical {
    vertical-align: middle;
    align-items: center;
  }
  .abajovertical {
    vertical-align: bottom;
  }
  .TituloGrilla {
    font-family: Tahoma;
    font-size: medium;
    font-weight: bold;
    background-color: darkgray;
  }
  .textoNegritaRojo {
    color:red !important;
    font-weight:bold !important;
  }
  .textoNegritaVerde{
    color:rgb(83, 248, 125) !important;
    font-weight:bold !important;
  }
</style>